export default __webpack_public_path__ + "static/media/29.33d8b28a.png";